import {
  SEARCH_GUEST_PREVIEW,
  SEARCH_GUEST_PROCESS_SUCCESS,
  SEARCH_GUEST_DATASOURCE_SUCCESS,
  SEARCH_GUEST_DETAIL_REQUEST,
  SEARCH_GUEST_DETAIL_DATASOURCE_SUCCESS,
  SEARCH_GUEST_DETAIL_FORM_DATASOURCE_SUCCESS,
  SEARCH_GUEST_PROCESS_RESET,

  RESET_STATE_SEARCH_GUEST,
  GET_GUEST,
  GET_GUEST_PROCESS_SUCCESS,
  GET_MAIN_GUEST,
  RESET_STATE_MAIN_GUEST,
  MSG_AlERT_BOOKING,
  UPDATE_GUEST_REQUEST,
  UPDATE_GUEST_SUCCESS,
  UPDATE_GUEST_FAILURE,
  UPDATE_GUEST_RESET,
  CREATE_GUEST_REQUEST,
  CREATE_GUEST_SUCCESS,
  CREATE_GUEST_FAILURE,
  CREATE_GUEST_RESET,
  MERGE_GUEST_REQUEST,
  MERGE_GUEST_SUCCESS,
  MERGE_GUEST_FAILURE,
  MERGE_GUEST_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSearchGuest: [],
  dataGuestById: [],
  dataMainGuestById: [],
  processStatus: false,
  msgBooking: '',
  loaderMsgBooking: false,

  guestDetail: {},
  guestDetailForm: {},
  process: { status: false, action: "", message: "", notiKey: "" },
  updateGuest: {
    loading: false,
    success: false,
    data: null,
    error: null
  },
  createGuest: {
    loading: false,
    success: false,
    data: null,
    error: null
  },
  mergeGuest: {
    loading: false,
    success: false,
    data: null,
    error: null
  },

  paging: {
    current: 1,
    limit: 20,
    total_rows: 0,
    row_count: 0
  }
}

export default (state = INIT_STATE, action) => {
switch (action.type) {

  case SEARCH_GUEST_DETAIL_REQUEST:{
    return{
      ...state,
      loader:true,
      guestDetail:{},
      guestDetailForm:{}
    }
  }
  case SEARCH_GUEST_DETAIL_DATASOURCE_SUCCESS:{
    return{
      ...state,
      loader:false,
      guestDetail:action.payload
    }
  }
  case SEARCH_GUEST_DETAIL_FORM_DATASOURCE_SUCCESS:{
    return{
      ...state,
      loader:false,
      guestDetailForm:action.payload
    }
  }

  case SEARCH_GUEST_PROCESS_SUCCESS:{
    return{
      ...state,
      process:action.payload
    }
  }
  case SEARCH_GUEST_PROCESS_RESET:{
    return{
      ...state,
      process:{status:false,action:"",message:"",notiKey:""},
      updateGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      },
      createGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      },
      mergeGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      }
    }
  }

  case RESET_STATE_SEARCH_GUEST:{
    return{
      ...state,
      loader: false,
      dataSearchGuest:[],
      guestDetail:{},
      guestDetailForm:{},
      process:{status:false,action:"",message:"",notiKey:""},
      updateGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      },
      createGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      },
      mergeGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      }
    }
  }
  case MSG_AlERT_BOOKING: {
    return {
      ...state,
      loaderMsgBooking:false,
      msgBooking: action.payload,
    }
  }
  case RESET_STATE_MAIN_GUEST:{
    return{
      ...state,
      loader: false,
      dataSearchGuest:[],
      dataMainGuestById:[],
      processStatus:false,
      process:{status:false,action:"",message:"",notiKey:""},
      updateGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      },
      createGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      },
      mergeGuest:{
        loading:false,
        success:false,
        data:null,
        error:null
      }
    }
  }
  case SEARCH_GUEST_PREVIEW: {
    return {
      ...state,
      loader: true,
      paging: {
        ...state.paging,
        current: action.payload?.page || 1,
        limit: action.payload?.limit || 20
      }
    }
  }
  case GET_GUEST:{
    return{
      ...state,
      loader:true
    }
  }
  case GET_GUEST_PROCESS_SUCCESS:{
    return {
      ...state,
      loader: false,
      dataGuestById: action.payload
    }
  }
  case GET_MAIN_GUEST:{
    return {
      ...state,
      loader: false,
      dataMainGuestById: action.payload
    }
  }
  case SEARCH_GUEST_DATASOURCE_SUCCESS:{
    return {
      ...state,
      loader: false,
       dataSearchGuest: action.payload.items || [],
    paging: action.payload.paging || {}
    }
  }
  case UPDATE_GUEST_REQUEST: {
    const requestData = action.payload?.data ?? action.payload
    return {
      ...state,
      updateGuest: {
        loading: true,
        success: false,
        data: requestData,
        error: null
      }
    }
  }
  case UPDATE_GUEST_SUCCESS: {
    return {
      ...state,
      updateGuest: {
        loading: false,
        success: true,
        data: action.payload,
        error: null
      }
    }
  }
  case UPDATE_GUEST_FAILURE: {
    return {
      ...state,
      updateGuest: {
        loading: false,
        success: false,
        data: null,
        error: action.payload
      }
    }
  }
  case UPDATE_GUEST_RESET: {
    return {
      ...state,
      updateGuest: {
        loading: false,
        success: false,
        data: null,
        error: null
      }
    }
  }
  case CREATE_GUEST_REQUEST: {
    const requestData = action.payload?.data ?? action.payload;
    return {
      ...state,
      createGuest: {
        loading: true,
        success: false,
        data: requestData,
        error: null
      }
    }
  }
  case CREATE_GUEST_SUCCESS: {
    return {
      ...state,
      createGuest: {
        loading: false,
        success: true,
        data: action.payload,
        error: null
      }
    }
  }
  case CREATE_GUEST_FAILURE: {
    return {
      ...state,
      createGuest: {
        loading: false,
        success: false,
        data: null,
        error: action.payload
      }
    }
  }
  case CREATE_GUEST_RESET: {
    return {
      ...state,
      createGuest: {
        loading: false,
        success: false,
        data: null,
        error: null
      }
    }
  }
  case MERGE_GUEST_REQUEST: {
    const requestData = action.payload?.data ?? action.payload;
    return {
      ...state,
      mergeGuest: {
        loading: true,
        success: false,
        data: requestData,
        error: null
      }
    }
  }
  case MERGE_GUEST_SUCCESS: {
    return {
      ...state,
      mergeGuest: {
        loading: false,
        success: true,
        data: action.payload,
        error: null
      }
    }
  }
  case MERGE_GUEST_FAILURE: {
    return {
      ...state,
      mergeGuest: {
        loading: false,
        success: false,
        data: null,
        error: action.payload
      }
    }
  }
  case MERGE_GUEST_RESET: {
    return {
      ...state,
      mergeGuest: {
        loading: false,
        success: false,
        data: null,
        error: null
      }
    }
  }
  default:
    return state
}
}
